import { Box, LinearProgress, Stack, useTheme } from '@mui/material';
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { useState } from 'react';
import { lighter } from '../common/util';
import SubjectAvatar from '../subject/subject.avatar';
import ScoreAvatar from './score.avatar';
import moment from 'moment';

export default function EnrollmentCard2(props) {
	const [enrollment, setEnrollment] = useState(props.enrollment);
	const theme = useTheme();

	if (!enrollment) {
		return;
	}

	const colour = enrollment.course?.colour || enrollment.course?.subject?.colour;
	const progressSx = {
		flexGrow: 1,
		height: 4,
		'.MuiLinearProgress-bar1Buffer': { backgroundColor: lighter(colour, 0.2, theme) },
		'.MuiLinearProgress-bar2Buffer': { backgroundColor: lighter(colour, 0.6, theme) },
	};

	const href = "/courses/" + enrollment.courseId + "/enrollments/" + enrollment.id;
	const linkActive = window.location.pathname != href;

	const cardMediaSx = { height: '100%', aspectRatio: '1 / 1' };
	const cardMedia = (
		<CardMedia sx={cardMediaSx}>
			<SubjectAvatar subject={enrollment.course.subject} />
		</CardMedia>
	);

	const cardContent = (
		<CardContent sx={{ p: 0, flex: 1, display: 'flex', alignItems: 'stretch' }}>
			<Stack sx={{ flex: 1, display: 'flex' }} alignItems="center">
				<Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
					<Typography sx={{ flex: 1, xtextWrap: 'nowrap', xoverflow: 'hidden' }}>{enrollment.course.name}</Typography>
				</Box>
				{enrollment.score > 0 &&
					<ScoreAvatar score={enrollment.score} size={24} />
				}
				{enrollment.startDate > new Date().getTime() && enrollment.completeness < 100 &&
					<Typography variant="subtitle2">{moment(enrollment.startDate).fromNow()}</Typography>
				}
			</Stack>
		</CardContent>
	);

	let cardDetail = (
		<Stack sx={{ p: 2, flex: 1, overflow: 'hidden' }} alignItems="stretch" justifyContent="start">
			{props.hideSubject != true && cardMedia}
			{cardContent}
		</Stack>
	);

	if (linkActive) {
		cardDetail = (
			<CardActionArea href={href} sx={{ textDecoration: 'none' }}>
				{cardDetail}
			</CardActionArea>
		);
	}

	const cardSx = { ...props.sx, background: lighter(colour, 0.8, theme) };
	return (
		<Card sx={cardSx}>
			{cardDetail}

			{enrollment.completeness > 0 &&
				<Box sx={{ mt: -1, mb: 0 }}>
					<LinearProgress title={enrollment.completeness?.toFixed(0) + '% Complete'} variant="buffer" value={enrollment.completeness} valueBuffer={100} sx={progressSx} color={enrollment.completeness >= 100 ? 'success' : 'info'} />
				</Box>
			}
		</Card>
	);
}